import { useState, useMemo } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import ArticleFeed from './components/ArticleFeed';
import HotTopics from './components/HotTopics';
import Newsletter from './components/Newsletter';
import { articles } from '@/mocks/articles';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredArticles = useMemo(() => {
    if (activeCategory === 'all') return articles;
    return articles.filter((a) => a.category === activeCategory);
  }, [activeCategory]);

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料社区网',
    url: 'https://heiliao.shequ.cn/',
    description: '专注热门爆料、娱乐八卦与网红内容的社区聚合平台',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://heiliao.shequ.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黑料社区网 - 最新爆料与热门内容聚合平台',
    description: '黑料社区网是专注热门爆料、娱乐八卦与网红内容的社区聚合平台。第一时间获取最新黑料资讯、参与社区讨论、发现热门话题。',
    url: 'https://heiliao.shequ.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料社区网',
      url: 'https://heiliao.shequ.cn/',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="最新爆料与热门内容聚合平台"
        description="黑料社区网是专注热门爆料、娱乐八卦与网红内容的社区聚合平台。第一时间获取最新黑料资讯、参与社区讨论、发现热门话题，内容真实、更新及时，是吃瓜群众的首选信息社区。"
        keywords="黑料社区网,黑料社区最新爆料,网红黑料汇总,娱乐圈黑料八卦,热门吃瓜社区,黑料内容聚合,社区爆料平台"
        canonicalUrl="https://heiliao.shequ.cn/"
      />
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>

      <Navbar />
      <main>
        <HeroSection />

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="flex-1 min-w-0">
              <div className="mb-6">
                <CategoryTabs activeSlug={activeCategory} onSelect={setActiveCategory} />
              </div>
              <ArticleFeed articles={filteredArticles} />
            </div>

            <div className="w-full lg:w-[320px] flex-shrink-0">
              <div className="lg:sticky lg:top-20">
                <HotTopics />
              </div>
            </div>
          </div>
        </section>

        <Newsletter />
      </main>
      <Footer />
    </>
  );
}